import type { FaireProductEntity } from "../../entity_types/product";

export const p_m8fgq7zw9f: FaireProductEntity = {
  token: "p_m8fgq7zw9f",
  type: "product",
  name: "Shilajit Liquid Complex",
  brandToken: "b_9lnqwiw9kl",
  brandName: "Cymbiotika",
  imageUrl:
    "https://cdn.faire.com/fastly/ba4805ca053828fb8fad66b2b6be242c737cb2630a2f350d60e42635aa138c6f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7975c32fcf7b3810a4532f20be3426a6bb318a821d876b6ff917a9f79489a0da.jpeg",
  ],
  priceDollars: 54.87,
  description:
    "Elevate your daily ritual with Cymbiotika’s Shilajit Liquid Complex, a groundbreaking fusion of tradition and modern science. Crafted to energize the body, sharpen the mind, and awaken the senses, this potent formula unites high-altitude micronized shilajit with a curated blend of superfoods: organic Peruvian cacao, wild Brazilian honey, Icelandic sea salt, and creamy hazelnut butter.\n\nEach dose delivers bioavailable fulvic minerals and essential nutrients to support cognitive function, sustained energy, and overall balance. This rich mix of hazelnut and cacao turns your daily ritual into something crave-worthy and packed with benefits.\n\nTransform your wellness routine with a supplement that tastes as good as it feels. The future of shilajit starts now.",
  tags: [],
  msrpDollars: 91.44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:51.391Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
